'use es6';

import * as customWidgetsClient from 'DesignData/api/CustomWidgets';
import * as layoutsClient from 'DesignData/api/Layouts';
import * as templatesClient from 'DesignData/api/Templates';
import * as globalWidgetsClient from 'DesignData/api/GlobalWidgets';
import * as rawAssetsClient from 'DesignData/api/RawAssets';
import { LAYOUT, TEMPLATE, CUSTOM_WIDGET, GLOBAL_GROUP, GLOBAL_WIDGET, CSS, JS, RAW_ASSET } from 'DesignData/constants/FolderAssetTypes';

function getClient(fileType) {
  switch (fileType) {
    case CUSTOM_WIDGET:
      return customWidgetsClient;

    case LAYOUT:
    case GLOBAL_GROUP:
      return layoutsClient;

    case TEMPLATE:
    case CSS:
    case JS:
      return templatesClient;

    case GLOBAL_WIDGET:
      return globalWidgetsClient;

    case RAW_ASSET:
      return rawAssetsClient;

    default:
      throw new Error(`Unable to get API client for file type '${fileType}'.`);
  }
}

export function create(fileType, data) {
  return getClient(fileType).create(data);
}
export function fetch(fileType, fileId) {
  return getClient(fileType).fetch(fileId);
}
export function save(fileType, fileId, data) {
  return getClient(fileType).save(fileId, data);
}
export function del(fileType, fileId) {
  return getClient(fileType).del(fileId);
}
export function bulkDelete(fileType, fileIds) {
  return getClient(fileType).bulkDelete(fileIds);
}
export function clone(fileType, fileId, data) {
  return getClient(fileType).clone(fileId, data);
}
export function restoreDeleted(fileType, fileId) {
  return getClient(fileType).restoreDeleted(fileId);
}
export function createByPath(fileType, path, data) {
  return getClient(fileType).createByPath(path, data);
}
export function cloneByPath(fileType, path, data) {
  return getClient(fileType).cloneByPath(path, data);
}
export function saveByPath(fileType, path, data) {
  return getClient(fileType).saveByPath(path, data);
}